export function isMobileWeb(targetResolution: 'sm' | 'md' | 'lg' = 'sm'): boolean {
  try {
    // Breakpoints do Chakra UI (definidos em chakraTheme.ts)
    const breakpoints = {
      sm: 480,
      md: 768,
      lg: 992,
    };

    const targetWidth = breakpoints[targetResolution];
    return window.innerWidth < targetWidth;
  } catch (e) {
    return false;
  }
}
